// Centralised TanStack Query key factory.
// Rule: every hook references qk.<domain>.<...args>, never inline arrays.
// This is the only place where the cache namespace is defined.

export type SearchFilters = Record<string, unknown>;

export const qk = {
  portfolio: {
    all: ['portfolio'] as const,
    search: (filters: SearchFilters) => [...qk.portfolio.all, 'search', filters] as const,
    summary: () => [...qk.portfolio.all, 'summary'] as const,
    facets: (filters: SearchFilters) => [...qk.portfolio.all, 'facets', filters] as const,
    detail: (policyId: string) => [...qk.portfolio.all, 'detail', policyId] as const,
  },
  claims: {
    all: ['claims'] as const,
    queue: (filters: SearchFilters) => [...qk.claims.all, 'queue', filters] as const,
    summary: () => [...qk.claims.all, 'summary'] as const,
    detail: (claimId: string) => [...qk.claims.all, 'detail', claimId] as const,
  },
  compliance: {
    all: ['compliance'] as const,
    queue: (filters: SearchFilters) => [...qk.compliance.all, 'queue', filters] as const,
    summary: () => [...qk.compliance.all, 'summary'] as const,
    detail: (sessionId: string) => [...qk.compliance.all, 'detail', sessionId] as const,
  },
  receipt: {
    all: ['receipt'] as const,
    opsSummary: (orgId: string | undefined) => [...qk.receipt.all, 'ops-summary', orgId] as const,
    openBatches: (orgId: string | undefined) => [...qk.receipt.all, 'open-batches', orgId] as const,
    arrears: (filters: SearchFilters) => [...qk.receipt.all, 'arrears', filters] as const,
    batchDetail: (batchId: string) => [...qk.receipt.all, 'batch', batchId] as const,
    batchItems: (batchId: string) => [...qk.receipt.all, 'batch', batchId, 'items'] as const,
    batchSummary: (batchId: string) => [...qk.receipt.all, 'batch', batchId, 'summary'] as const,
  },
  approvalState: {
    all: ['approval-state'] as const,
    me: () => [...qk.approvalState.all, 'me'] as const,
  },
  provisioning: {
    all: ['provisioning'] as const,
    validate: (token: string) => [...qk.provisioning.all, 'validate', token] as const,
  },
} as const;
